import React from 'react';
import style from './AiAssistantFreshdesk.module.css';
import { clsx } from 'clsx';
import { Container } from '@/components/Containers/Container';
import { Typography } from '@/components/Typography/Typography';

export const AiAssistantFreshdesk = () => {
  return (
    <section className={clsx('relative bg-light')}>
      <Container className="md:pt-18-vw md:pb-24.5-vw pb-6 pt-15">
        <div className="flex flex-col items-center lg:gap-7.5-vw gap-6">
          <Typography
            as="h2"
            $type="Heading1"
            className="font-formula text-center lg:max-w-[70%] lg:mb-3"
          >
            AI Assistant for Freshdesk, Customized and Trained on Your Customer Data
          </Typography>
          <div className={clsx(style.block, 'max-lg:flex-col-reverse')}>
            <div className={style.text}>
              <Typography as="h3" $type="Heading2Big" className="font-formula">
                Achieve Mathematical Precision in Responses
              </Typography>
              <Typography $type="Heading4">
                Imagine responses that consider every detail of conversations. Human agents can't
                handle such information volume. CoSupport Agent deals with this task effortlessly,
                providing relevant answers by analyzing conversation content in real time.
              </Typography>
            </div>
            <div>
              <picture className="w-full h-full object-contain">
                <source
                  srcSet="/img/freshdesk-integration/ai-assistant-zendesk-1.webp"
                  media="(min-width: 640px)"
                />
                <img
                  className="h-full w-full object-contain object-bottom"
                  src="/img/freshdesk-integration/ai-assistant-zendesk-1-mobile.webp"
                  alt={`ai-assistant-zendesk-1 image`}
                />
              </picture>
            </div>
          </div>
          <div className={clsx(style.block, 'max-lg:flex-col-reverse lg:flex-row-reverse')}>
            <div className={style.text}>
              <Typography as="h3" $type="Heading2Big" className="font-formula">
                Solve All Tasks in One Interface
              </Typography>
              <Typography $type="Heading4">
                CoSupport AI’s integration with Freshdesk is native: your agents work in the same
                Freshdesk interface but with extended functionality. Response suggestions are
                created automatically by AI and can be edited. Sending a response takes one click.
              </Typography>
            </div>
            <div>
              <picture className="w-full h-full object-contain">
                <source
                  srcSet="/img/freshdesk-integration/ai-assistant-zendesk-2.webp"
                  media="(min-width: 640px)"
                />
                <img
                  className="h-full w-full object-contain object-bottom"
                  src="/img/freshdesk-integration/ai-assistant-zendesk-2-mobile.webp"
                  alt={`ai-assistant-zendesk-1 image`}
                />
              </picture>
            </div>
          </div>
          <div className={clsx(style.block, 'max-lg:flex-col-reverse')}>
            <div className={style.text}>
              <Typography as="h3" $type="Heading2Big" className="font-formula">
                Benefit from the Ultimate AI Assistant Context-Awareness
              </Typography>
              <Typography $type="Heading4">
                CoSupport Agent learns everything needed for personalized responses, focusing on
                each customer’s experience and preferences. It generates unique, tailored answers
                that provide clients with the information they want and make each customer feel
                exceptional.
              </Typography>
            </div>
            <div>
              <picture className="w-full h-full object-contain">
                <source
                  srcSet="/img/freshdesk-integration/ai-assistant-zendesk-3.webp"
                  media="(min-width: 640px)"
                />
                <img
                  className="h-full w-full object-contain object-bottom"
                  src="/img/freshdesk-integration/ai-assistant-zendesk-3-mobile.webp"
                  alt={`ai-assistant-zendesk-1 image`}
                />
              </picture>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};
